<div>
	<nz-table
		#reportingTable
		[nzShowPagination]="true"
		[nzFrontPagination]="true"
		[nzPageSize]="10"
		[nzTotal]="rows.length"
		[nzData]="rows"
		[nzLoading]="loading"
		[nzBordered]="false"
		nzSize="middle"
	>
		<thead>
			<tr>
				@for (column of columns; track column) {
					<th
						[nzSortOrder]="column.sortOrder ? column.sortOrder : null"
						[nzSortFn]="column.sortFn ? column.sortFn : null"
						[nzSortDirections]="column.sortDirections ? column.sortDirections : ['ascend', 'descend', null]"
						[nzShowSort]="column.sortFn ? true : false"
						[nzShowFilter]="column.filterOptions ? true : false"
						[nzFilterMultiple]="column.filterMultiple ? column.filterMultiple : false"
						[nzFilters]="column.filterOptions ? column.filterOptions : []"
						[nzFilterFn]="column.filterFn ? column.filterFn : null"
					>
						<ng-container *ngTemplateOutlet="headerMap.get(column.key)"></ng-container>
					</th>
				}
			</tr>
		</thead>
		<tbody>
			@for (row of reportingTable.data; track row) {
				<tr class="row">
					@for (column of columns; track column) {
						<td>
							<ng-container
								*ngTemplateOutlet="cellMap.get(column.key); context: { $implicit: row, row: row }"
							></ng-container>
						</td>
					}
				</tr>
			}
		</tbody>
	</nz-table>
</div>
